// api.js
import API from 'config/ApiConfig';

const API_BASE_URL = API.API_ADMIN;

// Fungsi untuk mendapatkan token JWT dari localStorage
function getToken() {
    return localStorage.getItem('authToken');
}

// Fungsi untuk mendapatkan header dengan token JWT
function getAuthHeaders() {
    const token = getToken();
    if (!token) {
        throw new Error('No token available');
    }
    return {
        'Authorization': `Bearer ${token}`, // Format token JWT
        'Content-Type': 'application/json' // Jika perlu, untuk menentukan jenis konten
    };
}

// Fungsi untuk mendapatkan data siswa
export async function fetchSiswa() {
    try {
        const response = await fetch(`${API_BASE_URL}/siswa`, {
            method: 'GET',
            headers: getAuthHeaders()
        });
        if (response.status === 401) {
            console.error('Token is invalid or expired. Please log in again.');
        }
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching siswa data:', error);
        throw error;
    }
}

// Fungsi untuk mendapatkan data tentor
export async function fetchTentor() {
    try {
        const response = await fetch(`${API_BASE_URL}/tentor`, {
            method: 'GET',
            headers: getAuthHeaders()
        });
        if (response.status === 401) {
            console.error('Token is invalid or expired. Please log in again.');
        }
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching tentor data:', error);
        throw error;
    }
}

// Fungsi untuk mendapatkan data user
export async function fetchUser() {
    try {
        const response = await fetch(`${API_BASE_URL}/user`, {
            method: 'GET',
            headers: getAuthHeaders()
        });
        if (response.status === 401) {
            console.error('Token is invalid or expired. Please log in again.');
        }
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching user data:', error);
        throw error;
    }
}

// Fungsi untuk mendapatkan data rekap
export async function fetchRekap() {
    try {
        const response = await fetch(`${API_BASE_URL}/rekap`, {
            method: 'GET',
            headers: getAuthHeaders()
        });
        if (response.status === 401) {
            console.error('Token is invalid or expired. Please log in again.');
        }
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching rekap data:', error);
        throw error;
    }
}
